<template>
  <div
    class="time-left-card"
    :class="cardClass"
  >
    <div class="time-left-card__title">
      {{ $t('engineering.final-gradient.time-left') }}
    </div>
    <div class="time-left-card__content">
      <div class="time-left-card__item">
        <div class="time-left-card__label">{{ $t('engineering.final-gradient.for-alarm') }}</div>
      </div>
      <div class="time-left-card__item">
        <div class="time-left-card__label">{{ $t('engineering.final-gradient.for-shutdown') }}</div>
      </div>
    </div>
    <div class="time-left-card__content">
      <div class="time-left-card__item">
        <div class="time-left-card__badge"
          :class="getBadgeClass(alarm)"
        >
          <div class="time-left-card__value">
            <s-number
              fallback-value="--"
              :value="alarm.value"
              :number-format-options="numberFormatOptions"
            />
          </div>
          <div class="time-left-card__unit">
            {{ $t('general.minutes') }}
          </div>
        </div>
      </div>
      <div class="time-left-card__item">
        <div class="time-left-card__badge"
          :class="getBadgeClass(shutdown)"
        >
          <div class="time-left-card__value">
            <s-number
              fallback-value="--"
              :value="shutdown.value"
              :number-format-options="numberFormatOptions"
            />
          </div>
          <div class="time-left-card__unit">
            {{ $t('general.minutes') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const MINUTES_PRECISION = 0;

export default {
  name: 'TimeLeftCard',
  props: {
    timeLeft: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    alarm() {
      return (this.timeLeft || {}).alarm || {};
    },
    shutdown() {
      return (this.timeLeft || {}).shutdown || {};
    },
    hasSomeDiagnosisReached() {
      return this.alarm.timeForDiagnosisReached
        || this.shutdown.timeForDiagnosisReached;
    },
    cardClass() {
      return {
        'time-left-card--achieved-diagnosis': this.hasSomeDiagnosisReached,
      };
    },
    numberFormatOptions() {
      return {
        minimumFractionDigits: MINUTES_PRECISION,
        maximumFractionDigits: MINUTES_PRECISION,
      };
    },
  },
  methods: {
    getBadgeClass(itemData) {
      const { timeForDiagnosisReached, likelyAlarmTriggeredInIed } = itemData;
      return {
        'time-left-card__badge--achieved-diagnosis': (timeForDiagnosisReached
          || likelyAlarmTriggeredInIed),
      };
    },
  },
};
</script>

<style lang="sass" scoped>
$danger: 0 0 3px var(--color-danger-light)

.time-left-card
  min-height: 200px
  position: relative
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  flex: 1
  padding: 10px
  border: 1px solid var(--color-border-dark)
  border-radius: 5px

  &--achieved-diagnosis
    border: none
    box-shadow: $danger, inset $danger !important

  &__title
    position: absolute
    top: 5px
    font-weight: 700

  &__content
    width: 100%
    display: flex
    flex-direction: row
    justify-content: space-around
    align-items: center

  &__item
    width: 100%
    padding: 0 5px
    display: flex
    flex-direction: row
    justify-content: center
    text-align: center

  &__badge
    width: 100%
    max-width: 9rem
    padding: 2px
    background-color: var(--color-primary)
    border-radius: 2px
    color: #ffffff

    &--achieved-diagnosis
      background-color: var(--color-danger)

  &__label
    font-weight: 600

  &__value
    font-weight: 700
    font-size: 1.143rem
</style>


